// import axios from 'axios'
import axios from '../../helpers/Axios'

export const postcodemodule = {

	namespaced: true,

	state: {

		allPostcodes: []
	},
	getters: {

		allPostcodes: state => { return state.allPostcodes; }
	},
	actions: {

		getPostcodes({ commit }) {
			return axios.get('/postcode').then(response => {

				commit('allPostcodes', response.data);

			}).catch(err => {
				console.log(err);
			});
		}
	},
	mutations: {

		allPostcodes(state, postcodes) {
			state.allPostcodes = postcodes
		}
	}

}
